import { RouteObject } from "react-router-dom";
import GLEntityDashboard from "./components/landing/landing";
import CreateGlCode from "./components/create/create";
export interface GlRouteRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: GlRouteRoute[];
}
export const bxGlRouteRoute: GlRouteRoute[] = [
  {
    path: "/bx/gl-code",
    element: <GLEntityDashboard />,
  },
  {
    path: "/bx/gl-code/:action",
    element: <CreateGlCode />,
  },
  {
    path: "/bx/gl-code/:action/:glCode",
    element: <CreateGlCode />,
  },
];
